module.exports = __webpack_public_path__ + "files/5da25ff67eabaea694235ca9eede6c44.png";